import { render, staticRenderFns } from "./PaymentLogBody.vue?vue&type=template&id=6490d90a&"
import script from "./PaymentLogBody.vue?vue&type=script&lang=ts&"
export * from "./PaymentLogBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports